<template>
    <el-dialog class="preview-dialog" title="预览" :visible.sync="dialogVisible">
        <el-form class="preview-inlineForm" :inline="true" v-if="baseData">
            <el-form-item label="模板名称" :label-width="formLabelWidth">
                {{baseData.name}}
            </el-form-item>
            <el-form-item label="邮件标题" :label-width="formLabelWidth">
                <pre>{{baseData.title}}</pre>
            </el-form-item>
            <el-form-item label="招聘阶段" :label-width="formLabelWidth">
                {{getSelectMapText('WB_PHASE', baseData.phase)}}
            </el-form-item>
            <el-form-item label="用户类型" :label-width="formLabelWidth">
                {{getSelectMapText('WB_USER_ATTRIBUTES', baseData.userAttributes)}}
            </el-form-item>
            <el-form-item label="是否可用" :label-width="formLabelWidth">
                {{baseData.visible ? '可用' : '不可用'}}
            </el-form-item>
            <el-form-item label="是否私有" :label-width="formLabelWidth">
                {{baseData.isPrivate ? '是' : '否'}}
            </el-form-item>
        </el-form>
        <el-form  v-if="baseData">
            <el-form-item label="邮件内容" :label-width="formLabelWidth">
                <div v-html="baseData.content"></div>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<style lang="scss">
    .preview-inlineForm{
        .el-form-item__label{
            color: #9e9e9e;
        }
        .el-form-item{
            width: 300px;
            margin: 4px 0;
        }
        .el-form-item__content{
            width: 180px;
        }
    }
    .preview-dialog{
        pre{
            margin: 0;
            white-space: pre-line;
        }
        .el-form-item__label{
            color: #9e9e9e;
        }
        .el-form-item{
            margin: 4px 0;
        }
    }
</style>

<script>
    import axios from 'axios'
    import selectMapMixin from 'mixins/selectMapMixin'
    import { Loading } from 'element-ui'

    export default {
        mixins: [selectMapMixin],
        data () {
            return {
                configMap: this.$store.state.baseData.selectMap,
                formLabelWidth: '110px',
                baseData: null,
                dialogVisible: false
            }
        },
        methods: {
            getData (id) {
                axios.get('/system/mailTemplate/selectByKey.api?id=' + id).then(res => {
                    this.baseData = res.result.bean
                    this.dialogVisible = true
                })
            },
            show (id) {
                this.getData(id)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// viewEmailTpl.vue?91c5e310